import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Paper, Typography, Chip, Grid, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Layout from '../../components/layout/Layout';
import { getStores } from '../../Redux/Actions/storeAction';
import { getChangeRequests } from '../../Redux/Actions/changeRequestAction';
import { getPayments } from '../../Redux/Actions/paymentAction';

const REGIONS = [
  { key: 'EAST', label: 'TLJ EAST' },
  { key: 'WEST', label: 'TLJ WEST' },
];

function storePortalUserId(user) {
  if (!user) return null;
  return user.user?._id || user._id;
}

function TLJ({ user }) {
  const dispatch = useDispatch();
  const { stores } = useSelector(s => s.Store);
  const { requests } = useSelector(s => s.ChangeRequest);
  const { payments } = useSelector(s => s.Payment);

  const [regionTab, setRegionTab] = useState(0);
  const region = REGIONS[regionTab]?.key || 'EAST';
  const userId = storePortalUserId(user);

  useEffect(() => {
    if (userId && region) {
      dispatch(getStores(userId, { role: 'tlj_admin', tljRegion: region }));
    }
  }, [userId, region]);

  useEffect(() => {
    if (userId && stores?.length > 0) {
      const ids = stores.map(s => s._id);
      dispatch(getChangeRequests(userId, { storeIds: ids }));
      dispatch(getPayments(userId, { storeIds: ids }));
    }
  }, [userId, stores?.length]);

  const pendingRequests = (requests || []).filter(r => r.status === 'pending').length;
  const paidThisMonth = (payments || []).filter(p => p.status === 'paid').reduce((s, p) => s + (p.amount || 0), 0);

  return (
    <Layout title="TLJ 현황" user={user}>
      <Box sx={{ p: 2, maxWidth: 1200, mx: 'auto' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <StorefrontIcon sx={{ color: '#551FFF', fontSize: 28 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#551FFF' }}>
            TLJ Admin — 전체 현황
          </Typography>
        </Box>

        <Tabs value={regionTab} onChange={(_, v) => setRegionTab(v)} sx={{ borderBottom: 2, borderColor: 'divider', mb: 2 }}>
          {REGIONS.map((r, i) => (
            <Tab key={r.key} label={r.label} />
          ))}
        </Tabs>

        <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Paper sx={{ p: 2, minWidth: 140, borderRadius: 2, background: 'rgba(85,31,255,0.06)' }}>
            <Typography variant="caption" color="text.secondary">점포 수</Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#551FFF' }}>{stores?.length || 0}</Typography>
          </Paper>
          <Paper sx={{ p: 2, minWidth: 140, borderRadius: 2, background: '#fff8e1' }}>
            <Typography variant="caption" color="text.secondary">변경 요청 (대기)</Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#e65100' }}>{pendingRequests}</Typography>
          </Paper>
          <Paper sx={{ p: 2, minWidth: 140, borderRadius: 2, background: '#e8f5e9' }}>
            <Typography variant="caption" color="text.secondary">결제 완료 합계</Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#2e7d32' }}>${paidThisMonth.toFixed(0)}</Typography>
          </Paper>
        </Box>

        <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: '0 2px 8px rgba(85,31,255,0.08)' }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ background: '#f5f3ff' }}>
                <TableCell sx={{ fontWeight: 700 }}>TLJ No</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>주소</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>매장 전화</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>상태</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>결제 방식</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(stores || []).map(s => (
                <TableRow key={s._id} hover>
                  <TableCell>{s.tljNo || '-'}</TableCell>
                  <TableCell sx={{ fontSize: 12 }}>
                    {[s.address1, s.address2, s.town, s.state].filter(Boolean).join(', ') || '-'}
                  </TableCell>
                  <TableCell>{s.storePhone || '-'}</TableCell>
                  <TableCell>
                    <Chip
                      label={s.status === 'active' ? '운영중' : '비활성'}
                      size="small"
                      sx={{
                        background: s.status === 'active' ? '#e8f5e9' : '#fce4ec',
                        color: s.status === 'active' ? '#2e7d32' : '#c62828',
                        fontWeight: 600, fontSize: 11,
                      }}
                    />
                  </TableCell>
                  <TableCell>{s.paymentOption === 'yearly' ? '연간' : '월간'}</TableCell>
                </TableRow>
              ))}
              {(!stores || stores.length === 0) && (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4, color: '#888' }}>
                    해당 지역에 점포가 없습니다.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Layout>
  );
}

export default TLJ;
